import { render, staticRenderFns } from "./SidebarCreateApplicationMapSeeding.vue?vue&type=template&id=8220354a&scoped=true&"
import script from "./SidebarCreateApplicationMapSeeding.vue?vue&type=script&lang=ts&"
export * from "./SidebarCreateApplicationMapSeeding.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCreateApplicationMapSeeding.vue?vue&type=style&index=0&id=8220354a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8220354a",
  null
  
)

export default component.exports